/**
 * Original list of action names was taken from https://cloud.google.com/recaptcha-enterprise/docs/actions-website.
 *
 * Google Recaptcha docs have this to say about them:
 *
 * We recommend using action names that are unique, meaningful, and not specific to users. Action names are not case-sensitive and they can only contain alphanumeric characters, slashes, and underscores. If you have a page with multiple applicable actions, you can concatenate multiple action strings together, for example, cart_view_payment.
 *
 * End of the docs advice.
 *
 * Our advice:
 * If you plan to concatenate multiple action strings together, please hide this from the callers.
 * Instead, add the specific concatenated action string to the Action enum as a separate entry.
 *
 * This way, we can better avoid having similar action strings in different parts of the codebase.
 */
export enum RecaptchaAction {
    // Basic set recommended by Google Recaptcha docs.
    /** Sign up on the website. */
    'SignUp' = 'signup',
    /** Log in to the website. */
    'Login' = 'login',
    /** Request to reset the password. */
    'PasswordReset' = 'password_reset',
    /**  Fetch price for an item. */
    'GetPrice' = 'get_price',
    /** Add items to the cart. */
    'CardAdd' = 'cart_add',
    /** View the contents of the cart. */
    'CartView' = 'cart_view',
    /** Add or update payment information (e.g. card details or address). */
    'PaymentAdd' = 'payment_add',
    /** Check out from the website. */
    'CheckOut' = 'checkout',
    /** Confirmation that a transaction was processed. */
    'TransactionConfirmed' = 'transaction_confirmed',

    //  Custom set for our use cases.
    'PaymentRequestFullfill' = 'payment_request_fulfill',
}
